module.exports = __webpack_public_path__ + "img/phone_iphone-gray.a137207a.svg";